<template>
  <div class="report">
    <div class="head row align-center column-s">
      <h1 class="grid-3 grid-12-s text-center-s">Conta Azul</h1>
      <div class="filters row grid-10 grid-11-s column-s align-end justify-end">
        <div class="fil grid-3 grid-12-s column">
          <label>Pagamento</label>
          <select v-model="filters.status_pagamento" class="input">
            <option value="">Selecione</option>
            <option value="pago">Pago</option>
            <option value="pendente">Pendente</option>
          </select>
        </div>
        <div class="fil grid-3 grid-12-s column">
          <label>Inicio Pagamento</label>
          <input
            v-model="filters.data_inicio"
            type="date"
            class="input"
            placeholder="Inicio Pagamento"
          />
        </div>
        <div class="fil grid-3 grid-12-s column">
          <label>Fim Pagamento</label>
          <input
            v-model="filters.data_fim"
            type="date"
            class="input"
            placeholder="Fim Pagamento"
          />
        </div>
        <div class="fil grid-12-s row justify-center-s">
          <Button layout="green-go" @click="load()" :loader="loader"
            ><i class="fa fa-filter" /> GERAR</Button
          >
        </div>
      </div>
    </div>
    <div v-if="list.length" class="list">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <div class="sub row grid-12-s">
          <input class="input search" v-model="search" placeholder="Pesquisar" />
          <div class="row grid-9 justify-end">
            <div class="grid-2 column grid-12-s text-center-s">
              Registros <b>{{ list.length }}</b>
            </div>
          </div>
          <Button layout="green-go" @click="csv()" :loader="loader"
            ><i class="fa fa-filter" /> GERAR CSV</Button
          >
        </div>
        <div class="container">
          <div class="head row justify-space">
            <div class="grid-1">Data</div>
            <div class="grid-1">Atendimento</div>
            <div class="grid-1">Tipo</div>
            <div class="grid-2">Descrição</div>
            <div class="grid-1">Categoria</div>
            <div class="grid-1">Valor</div>
            <div class="grid-2">Centro de Custo</div>
            <div class="grid-2">Cliente / Fornecedor</div>
            <div class="grid-1">Observações</div>
            <div class="grid-1">Data Pagamento</div>
            <div class="grid-1">Valor Pagamento</div>
          </div>

          <div class="content">
            <div
              v-for="(item, i) of filtered"
              :key="'item' + i"
              class="line row justify-space"
            >
              <div class="grid-1">{{ item.data | date }}</div>
              <div class="grid-1">{{ item.atendimento | date }}</div>
              <div class="grid-1">{{ item.tipo }}</div>
              <div class="grid-2">{{ item.descricao }}</div>
              <div class="grid-1">{{ item.categoria }}</div>
              <div class="grid-1">{{ item.valor | money }}</div>
              <div class="grid-2">{{ item.centro_custo }}</div>
              <div class="grid-2">{{ item.cliente_fornecedor }}</div>
              <div class="grid-1">{{ item.observacoes }}</div>
              <div class="grid-1">{{ item.data_pagamento | date }}</div>
              <div class="grid-1">{{ item.valor_pagamento | money }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "Report",
  components: {
    Button,
    Loader,
  },
  data() {
    return {
      loader: false,
      search: "",
      csvButton: false,
      filters: {
        status_pagamento: "",
        data_inicio: "",
        data_fim: "",
      },
      list: [],
    };
  },
  methods: {
    ...mapActions("admin", ["REPORT_CONTAAZUL"]),
    async load() {
      this.loader = true;

      await this.REPORT_CONTAAZUL(this.filters)
        .then(({ data }) => (this.list = data || []))
        .catch(() => {
          this.loader = false;
          this.list = [];
        });

      this.loader = false;
    },

    async csv() {
      let csv =
        "atendimento;categoria;centro_custo;cliente_fornecedor;data;data_pagamento;descricao;observacoes;tipo;valor;valor_pagamento\n";

      this.list.map((item) => {
        csv += `${item.atendimento};${item.categoria};${item.centro_custo};${item.cliente_fornecedor};${item.data};${item.data_pagamento};${item.descricao};${item.observacoes};${item.tipo};${item.valor};${item.valor_pagamento}\n`;
      });

      var acsv = document.createElement("a");
      acsv.download = "relatorio-extrato-conta-azul.csv";
      acsv.href = `data:application/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      acsv.click();
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("report");
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.list.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.report
  @include page
</style>
